export default __webpack_public_path__ + "static/media/FillRate.fb9c2704.jpg";